import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=defb045e"
import script from "./on-boarding.ts?vue&type=script&lang=ts&external"
export * from "./on-boarding.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports